import { createTheme } from '@mui/material/styles';
// for date pickers
import type {} from '@mui/x-date-pickers/themeAugmentation';

const muiMain = createTheme({
  palette: {
    primary: {
      main: '#02ada9',
      contrastText: '#fff'
    },
    secondary: {
      main: '#ff3d00'
    },
    white: {
      main: '#fff'
    }
  },
  typography: {
    allVariants: {
      color: '#545f71'
    },
    subtitle1: {
      color: '#9ba5b7'
    }
  },
  components: {
    MuiMultiSectionDigitalClock: {
      styleOverrides: {
        root: {
          '&&': {
            '.MuiList-root': {
              width: '80px'
            }
          }
        }
      }
    }
  }
});

export default muiMain;
